'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getStatus = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _WMIconButton = require('./../WMIconButton');

var _WMIconButton2 = _interopRequireDefault(_WMIconButton);

var _WMFontIcon = require('./../WMFontIcon');

var _WMFontIcon2 = _interopRequireDefault(_WMFontIcon);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _styles3 = require('../common/styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/* eslint-disable jsx-a11y/no-static-element-interactions */

var _colors$baseColors = _styles3.colors.baseColors,
    blue = _colors$baseColors.blue,
    red = _colors$baseColors.red,
    orange = _colors$baseColors.orange,
    lightGreen = _colors$baseColors.lightGreen;


var propTypes = {
	children: _propTypes2.default.node.isRequired,
	status: _propTypes2.default.oneOf(['error', 'notice', 'warning', 'success']).isRequired,
	hideDismiss: _propTypes2.default.bool,
	onDismiss: _propTypes2.default.func
};

var getStatus = exports.getStatus = function getStatus(status) {
	var icon = '';
	var color = '';

	switch (status) {
		case 'error':
			icon = 'highlight_off';
			color = red;
			break;
		case 'notice':
			icon = 'info_outline';
			color = blue;
			break;
		case 'warning':
			icon = 'error_outline';
			color = orange;
			break;
		default:
			icon = 'check_circle';
			color = lightGreen;
	}

	return { icon: icon, color: color };
};

var WMMessageBanner = function (_Component) {
	_inherits(WMMessageBanner, _Component);

	function WMMessageBanner() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, WMMessageBanner);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WMMessageBanner.__proto__ || Object.getPrototypeOf(WMMessageBanner)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			open: true
		}, _this.closeBanner = function () {
			_this.setState({ open: false });
			if (_this.props.onDismiss) {
				_this.props.onDismiss();
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(WMMessageBanner, [{
		key: 'render',
		value: function render() {
			var open = this.state.open;
			var _props = this.props,
			    status = _props.status,
			    children = _props.children,
			    hideDismiss = _props.hideDismiss;

			var myStatus = getStatus(status);

			return _react2.default.createElement(
				'div',
				{
					'data-component-identifier': 'wm-message-banner-container',
					style: _styles2.default.banner(open, myStatus.color)
				},
				_react2.default.createElement(
					_WMFontIcon2.default,
					{
						id: 'wm-message-banner-icon',
						className: 'material-icons',
						color: myStatus.color,
						style: _styles2.default.icon
					},
					myStatus.icon
				),
				_react2.default.createElement(
					'div',
					{
						'data-component-identifier': 'wm-message-banner-text',
						style: _styles2.default.text
					},
					children
				),
				!hideDismiss && _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'a',
						{
							'data-component-identifier': 'wm-message-banner-anchor',
							onClick: this.closeBanner
						},
						_react2.default.createElement(
							_WMIconButton2.default,
							{
								iconClassName: 'material-icons',
								iconStyle: _styles2.default.close,
								style: _styles2.default.closeContainer
							},
							'close'
						)
					)
				)
			);
		}
	}]);

	return WMMessageBanner;
}(_react.Component);

WMMessageBanner.defaultProps = {
	hideDismiss: false
};

exports.default = WMMessageBanner;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMMessageBanner/index.js